export const ACCOUNT_MAIN_TYPES = {
  ASSET: "asset",
  LIABILITY: "liability",
  EQUITY: "equity",
  INCOME: "income",
  EXPENSE: "expense",
};

export const ACCOUNT_SUB_TYPES = {
  CASH: "cash",
  BANK: "bank",
  ACCOUNTS_RECEIVABLE: "accounts_receivable",
  ACCOUNTS_PAYABLE: "accounts_payable",
  SALES: "sales",
  DIRECT_EXPENSE: "direct_expense",
  OPERATING_EXPENSE: "operating_expense",
  TAX_PAYABLE: "tax_payable",
  TAX_RECEIVABLE: "tax_receivable",
  ADVANCE_RECEIVED: "advance_received",
  OWNER_CAPITAL: "owner_capital",
  RETAINED_EARNINGS: "retained_earnings",
};

export const ACCOUNT_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  ARCHIVED: "archived",
};

export const NORMAL_BALANCE = {
  DEBIT: "debit",
  CREDIT: "credit",
};

export const JOURNAL_TYPES = {
  SALES: "sales",
  RECEIPT: "receipt",
  PURCHASE: "purchase",
  PAYMENT: "payment",
  EXPENSE: "expense",
  GENERAL: "general",
  CONTRA: "contra",
  ADJUSTMENT: "adjustment",
  OPENING: "opening",
};

export const JOURNAL_STATUS = {
  DRAFT: "draft",
  POSTED: "posted",
  CANCELLED: "cancelled",
  REVERSED: "reversed",
};

export const SALES_INVOICE_STATUS = {
  DRAFT: "draft",
  SENT: "sent",
  PARTIALLY_PAID: "partially_paid",
  PAID: "paid",
  OVERDUE: "overdue",
  CANCELLED: "cancelled",
  VOID: "void",
};

export const PURCHASE_BILL_STATUS = {
  DRAFT: "draft",
  RECORDED: "recorded",
  PARTIALLY_PAID: "partially_paid",
  PAID: "paid",
  OVERDUE: "overdue",
  CANCELLED: "cancelled",
  VOID: "void",
};

export const RECEIPT_STATUS = {
  DRAFT: "draft",
  RECEIVED: "received",
  DEPOSITED: "deposited",
  BOUNCED: "bounced",
  CANCELLED: "cancelled",
};

export const PAYMENT_STATUS = {
  DRAFT: "draft",
  PAID: "paid",
  BOUNCED: "bounced",
  CANCELLED: "cancelled",
};

export const PAYMENT_METHODS = {
  CASH: "cash",
  BANK_TRANSFER: "bank_transfer",
  UPI: "upi",
  CARD: "card",
  CHEQUE: "cheque",
  PAYMENT_GATEWAY: "payment_gateway",
};

export const BANK_ACCOUNT_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  CLOSED: "closed",
};

export const RECON_STATUS = {
  NOT_RECONCILED: "not_reconciled",
  PARTIALLY_RECONCILED: "partially_reconciled",
  RECONCILED: "reconciled",
};

export const TAX_TYPES = {
  GST: "gst",
  TDS: "tds",
  NONE: "none",
};

export const ACCOUNT_MAIN_TYPE_OPTIONS = [
  { value: ACCOUNT_MAIN_TYPES.ASSET, label: "Asset" },
  { value: ACCOUNT_MAIN_TYPES.LIABILITY, label: "Liability" },
  { value: ACCOUNT_MAIN_TYPES.EQUITY, label: "Equity" },
  { value: ACCOUNT_MAIN_TYPES.INCOME, label: "Income" },
  { value: ACCOUNT_MAIN_TYPES.EXPENSE, label: "Expense" },
];

export const JOURNAL_TYPE_OPTIONS = [
  { value: JOURNAL_TYPES.SALES, label: "Sales" },
  { value: JOURNAL_TYPES.RECEIPT, label: "Receipt" },
  { value: JOURNAL_TYPES.PURCHASE, label: "Purchase" },
  { value: JOURNAL_TYPES.PAYMENT, label: "Payment" },
  { value: JOURNAL_TYPES.EXPENSE, label: "Expense" },
  { value: JOURNAL_TYPES.GENERAL, label: "General" },
  { value: JOURNAL_TYPES.CONTRA, label: "Contra" },
  { value: JOURNAL_TYPES.ADJUSTMENT, label: "Adjustment" },
  { value: JOURNAL_TYPES.OPENING, label: "Opening" },
];

export const JOURNAL_STATUS_OPTIONS = [
  { value: JOURNAL_STATUS.DRAFT, label: "Draft" },
  { value: JOURNAL_STATUS.POSTED, label: "Posted" },
  { value: JOURNAL_STATUS.CANCELLED, label: "Cancelled" },
  { value: JOURNAL_STATUS.REVERSED, label: "Reversed" },
];

export const SALES_INVOICE_STATUS_OPTIONS = [
  { value: SALES_INVOICE_STATUS.DRAFT, label: "Draft" },
  { value: SALES_INVOICE_STATUS.SENT, label: "Sent" },
  { value: SALES_INVOICE_STATUS.PARTIALLY_PAID, label: "Partially Paid" },
  { value: SALES_INVOICE_STATUS.PAID, label: "Paid" },
  { value: SALES_INVOICE_STATUS.OVERDUE, label: "Overdue" },
  { value: SALES_INVOICE_STATUS.CANCELLED, label: "Cancelled" },
  { value: SALES_INVOICE_STATUS.VOID, label: "Void" },
];

export const PURCHASE_BILL_STATUS_OPTIONS = [
  { value: PURCHASE_BILL_STATUS.DRAFT, label: "Draft" },
  { value: PURCHASE_BILL_STATUS.RECORDED, label: "Recorded" },
  { value: PURCHASE_BILL_STATUS.PARTIALLY_PAID, label: "Partially Paid" },
  { value: PURCHASE_BILL_STATUS.PAID, label: "Paid" },
  { value: PURCHASE_BILL_STATUS.OVERDUE, label: "Overdue" },
  { value: PURCHASE_BILL_STATUS.CANCELLED, label: "Cancelled" },
  { value: PURCHASE_BILL_STATUS.VOID, label: "Void" },
];

export const PAYMENT_METHOD_OPTIONS = [
  { value: PAYMENT_METHODS.CASH, label: "Cash" },
  { value: PAYMENT_METHODS.BANK_TRANSFER, label: "Bank Transfer" },
  { value: PAYMENT_METHODS.UPI, label: "UPI" },
  { value: PAYMENT_METHODS.CARD, label: "Card" },
  { value: PAYMENT_METHODS.CHEQUE, label: "Cheque" },
  { value: PAYMENT_METHODS.PAYMENT_GATEWAY, label: "Payment Gateway" },
];

export const DEFAULT_ACCOUNT_FILTERS = {
  mainType: "all",
  subType: "all",
  status: "all",
  search: "",
};

export const DEFAULT_INVOICE_FILTERS = {
  status: "all",
  customerId: "all",
  projectId: "all",
  search: "",
  fromDate: "",
  toDate: "",
};

export const DEFAULT_BILL_FILTERS = {
  status: "all",
  vendorId: "all",
  search: "",
  fromDate: "",
  toDate: "",
};

export const DEFAULT_JOURNAL_FILTERS = {
  status: "all",
  type: "all",
  search: "",
  fromDate: "",
  toDate: "",
};

export const ERROR_MESSAGES = {
  FETCH_FAILED: "Failed to fetch accounts data.",
  FETCH_ONE_FAILED: "Failed to fetch details.",
  CREATE_FAILED: "Failed to create record.",
  UPDATE_FAILED: "Failed to update record.",
  DELETE_FAILED: "Failed to delete record.",
  INVALID_JOURNAL: "Journal entry is not balanced.",
  ACCOUNT_NAME_REQUIRED: "Account name is required.",
  ACCOUNT_CODE_REQUIRED: "Account code is required.",
  CUSTOMER_REQUIRED: "Customer is required.",
  VENDOR_REQUIRED: "Vendor is required.",
};

export const SUCCESS_MESSAGES = {
  ACCOUNT_CREATED: "Account created successfully.",
  ACCOUNT_UPDATED: "Account updated successfully.",
  INVOICE_CREATED: "Invoice created successfully.",
  BILL_CREATED: "Bill created successfully.",
  RECEIPT_CREATED: "Receipt created successfully.",
  PAYMENT_CREATED: "Payment recorded successfully.",
  JOURNAL_CREATED: "Journal entry created successfully.",
  JOURNAL_POSTED: "Journal posted successfully.",
};
